"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@chakra-ui/react");
const StackedLayout = ({ children }) => (jsx_runtime_1.jsx(react_1.Box, Object.assign({ py: "8", mt: "16" }, { children: children }), void 0));
exports.default = StackedLayout;
